import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 41,
	viewBox: "0 0 50 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 22.5,
			cy: 17.5,
			r: 17.5,
			fill: "#F6F5FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0083 34.3346H33.9817C37.6617 34.3346 39.1283 32.0813 39.3017 29.3346L39.995 18.3213C40.1817 15.4413 37.8883 13.0013 34.995 13.0013C34.1817 13.0013 33.435 12.5346 33.0617 11.8146L32.1017 9.8813C31.4883 8.66797 29.8883 7.66797 28.5283 7.66797H25.475C24.1017 7.66797 22.5017 8.66797 21.8883 9.8813L20.9283 11.8146C20.555 12.5346 19.8083 13.0013 18.995 13.0013C16.1017 13.0013 13.8083 15.4413 13.995 18.3213L14.6883 29.3346C14.8483 32.0813 16.3283 34.3346 20.0083 34.3346Z",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 25H23M27 21V29",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.7396 17.6094H33.4062",
			stroke: "#BCA4FF",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 42,
			cy: 10,
			r: 1,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 49,
			cy: 9,
			r: 1,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 32.5,
			r: 1.5,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 39,
			r: 2,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 2,
			cy: 33,
			r: 2,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 43,
			cy: 2,
			r: 2,
			fill: "#CAEDDA"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 44.5,
			cy: 13.5,
			r: 1.5,
			fill: "#F0EEFF"
		})
	]
});
export default SvgUploadImage;
